import { Injectable, InjectionToken } from '@angular/core';
import { Observable, from } from 'rxjs';

import { HttpClient, HttpParams } from '@angular/common/http';
import {
  UpdateRunStatusParams,
  UpdateRunNoteParams,
  IRunManagementService,
} from './definitions';
import { environment } from '@env/environment';

export const RunManagementServiceToken =
  new InjectionToken<IRunManagementService>('RunManagementService');

@Injectable({
  providedIn: 'root',
})
export class RunManagementService implements IRunManagementService {
  private baseUrl: string;

  public constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/runs`;
  }

  public getAll(data?: any): Observable<{ data: []; count: number }> {
    let url = `${this.baseUrl}/run-search`;

    if (!data) {
      return from(this.http.get<{ data: []; count: number }>(url));
    }

    const { offset = 0, limit = 0, searchParams = {} } = data;

    const strqs = {
      ...searchParams,
      offset,
      limit,
      scheduleType: (searchParams.scheduleType || []).join(','),
    };

    const params = new HttpParams({ fromObject: strqs });

    return from(this.http.get<{ data: []; count: number }>(url, { params }));
  }

  /**
   * update a run status
   */

  public updateRunStatus(params: UpdateRunStatusParams) {
    const { id, statusTag } = params;

    const apiEndpoint = `${this.baseUrl}/item/${id}/status`;

    const data = {
      runStatusTag: statusTag,
    };

    return this.http.post(apiEndpoint, data);
  }

  /**
   * update a run status
   */

  public updateRunNote(params: UpdateRunNoteParams) {
    const { id, notes } = params;
    const apiEndpoint = `${this.baseUrl}/${id}/notes`;

    const data = {
      notes,
    };

    return this.http.put(apiEndpoint, data);
  }

  public export(params?: any): Observable<any> {
    let url = `${this.baseUrl}/run-search`;

    const { mode = 'search' } = params;

    url = `${url}?mode=${mode}`;

    return from(this.http.get<any>(url));
  }
}
